import React from 'react'
import UsersList from './UsersList'

export default function ActiveUsersTab ({ activeUsers, deleteUser }) {
  return (
    <UsersList users={activeUsers} deleteUser={deleteUser} />
  )
}
